import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["required", "aria-required"]
const _hoisted_7 = ["required", "aria-required"]
const _hoisted_8 = { value: "yesByClient" }
const _hoisted_9 = { value: "yesByInsurer" }
const _hoisted_10 = ["required", "aria-required"]
const _hoisted_11 = { key: 2 }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["min", "max"]
const _hoisted_14 = {
  for: "ablaufEinJahr",
  class: "radiolabel"
}
const _hoisted_15 = {
  key: 0,
  for: "ablaufJanuar",
  class: "radiolabel"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ueberschrift = _resolveComponent("ueberschrift")!
  const _component_titel_zelle = _resolveComponent("titel-zelle")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!
  const _component_zelle = _resolveComponent("zelle")!
  const _component_zeile = _resolveComponent("zeile")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ueberschrift, { titel: "Angaben zur Versicherung" }),
    (!_ctx.antragsartSichtbar)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_zeile, null, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, null, {
                default: _withCtx(() => _cache[13] || (_cache[13] = [
                  _createTextVNode("Ihr Anliegen")
                ])),
                _: 1,
                __: [13]
              }),
              _createVNode(_component_zelle, {
                breite: 8,
                class: "mkRadio"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: "vorversicherungAntragsartFirstTime",
                    name: "vorversicherungAntragsart",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.piniaStore.state.vorversicherung.antragsart) = $event)),
                    value: "neu",
                    required: "",
                    "aria-required": "true",
                    "aria-label": "Erstmalig versichern",
                    disabled: _ctx.istAenderungsantragMitVorbelegung,
                    "data-cy": "vorversicherungAntragsartErstmalig"
                  }, null, 8, _hoisted_1), [
                    [_vModelRadio, _ctx.piniaStore.state.vorversicherung.antragsart]
                  ]),
                  _createElementVNode("label", {
                    for: "vorversicherungAntragsartFirstTime",
                    class: _normalizeClass(["radiolabel", {
            'radiolabel--disabled': _ctx.istAenderungsantragMitVorbelegung,
          }])
                  }, "Erstmalig versichern", 2),
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: "vorversicherungAntragsartTypeTransfer",
                    name: "vorversicherungAntragsart",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.piniaStore.state.vorversicherung.antragsart) = $event)),
                    value: "wechsel",
                    "aria-label": "Versicherer wechseln",
                    disabled: _ctx.istAenderungsantragMitVorbelegung,
                    "data-cy": "vorversicherungAntragsartWechsel"
                  }, null, 8, _hoisted_2), [
                    [_vModelRadio, _ctx.piniaStore.state.vorversicherung.antragsart]
                  ]),
                  _createElementVNode("label", {
                    for: "vorversicherungAntragsartTypeTransfer",
                    class: _normalizeClass(["radiolabel", {
            'radiolabel--disabled': _ctx.istAenderungsantragMitVorbelegung,
          }])
                  }, "Versicherer wechseln", 2),
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: "vorversicherungAntragsartModification",
                    name: "vorversicherungAntragsart",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.piniaStore.state.vorversicherung.antragsart) = $event)),
                    value: "aenderung",
                    "aria-label": "Bestehenden Vertrag ändern",
                    "data-cy": "vorversicherungAntragsartAenderung"
                  }, null, 512), [
                    [_vModelRadio, _ctx.piniaStore.state.vorversicherung.antragsart]
                  ]),
                  _cache[14] || (_cache[14] = _createElementVNode("label", {
                    for: "vorversicherungAntragsartModification",
                    class: "radiolabel"
                  }, "Bestehenden Vertrag ändern", -1)),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.vorversicherungAntragsart,
                    "reduzierter-abstand": true
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1,
                __: [14]
              })
            ]),
            _: 1
          }),
          (_ctx.piniaStore.state.vorversicherung.antragsart === 'neu' && _ctx.piniaStore.state.verkaufsprodukt === 'VGV')
            ? (_openBlock(), _createBlock(_component_zeile, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_titel_zelle, null, {
                    default: _withCtx(() => _cache[15] || (_cache[15] = [
                      _createTextVNode("Bestand für das Gebäude eine Versicherung?")
                    ])),
                    _: 1,
                    __: [15]
                  }),
                  _createVNode(_component_zelle, {
                    breite: 8,
                    class: "mkRadio"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        id: "vorversicherungVorhandenNein",
                        name: "vorversicherungVorhanden",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.piniaStore.state.vorversicherung.vorhanden) = $event)),
                        value: false,
                        required: "",
                        "aria-required": "true",
                        "aria-label": "Nein, es bestand keine Vorversicherung",
                        disabled: _ctx.istAenderungsantragMitVorbelegung,
                        "data-cy": "vorversicherungVorhandenNein"
                      }, null, 8, _hoisted_3), [
                        [_vModelRadio, _ctx.piniaStore.state.vorversicherung.vorhanden]
                      ]),
                      _createElementVNode("label", {
                        for: "vorversicherungVorhandenNein",
                        class: _normalizeClass(["radiolabel", {
            'radiolabel--disabled': _ctx.istAenderungsantragMitVorbelegung,
          }])
                      }, "Nein", 2),
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        id: "vorversicherungVorhandenJa",
                        name: "vorversicherungVorhanden",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.piniaStore.state.vorversicherung.vorhanden) = $event)),
                        value: true,
                        "aria-label": "Ja, es bestand eine Vorversicherung",
                        disabled: _ctx.istAenderungsantragMitVorbelegung,
                        "data-cy": "vorversicherungVorhandenJa"
                      }, null, 8, _hoisted_4), [
                        [_vModelRadio, _ctx.piniaStore.state.vorversicherung.vorhanden]
                      ]),
                      _createElementVNode("label", {
                        for: "vorversicherungVorhandenJa",
                        class: _normalizeClass(["radiolabel", {
            'radiolabel--disabled': _ctx.istAenderungsantragMitVorbelegung,
          }])
                      }, "Ja", 2),
                      _createVNode(_component_validierungs_fehler, {
                        "fehler-text": _ctx.fehler.vorversicherungVorhanden,
                        "reduzierter-abstand": true
                      }, null, 8, ["fehler-text"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (
        _ctx.piniaStore.state.vorversicherung.antragsart === 'wechsel' || _ctx.piniaStore.state.vorversicherung.vorhanden === true
      )
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_zeile, null, {
                  default: _withCtx(() => [
                    (_ctx.piniaStore.state.vorversicherung.antragsart === 'wechsel')
                      ? (_openBlock(), _createBlock(_component_titel_zelle, { key: 0 }, {
                          default: _withCtx(() => _cache[16] || (_cache[16] = [
                            _createTextVNode("Bisheriger Versicherer")
                          ])),
                          _: 1,
                          __: [16]
                        }))
                      : (_openBlock(), _createBlock(_component_titel_zelle, { key: 1 }, {
                          default: _withCtx(() => _cache[17] || (_cache[17] = [
                            _createTextVNode("Vorversicherung des Gebäudes")
                          ])),
                          _: 1,
                          __: [17]
                        })),
                    _createVNode(_component_zelle, null, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "vorversicherungGesellschaft",
                          name: "vorversicherungGesellschaft",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.piniaStore.state.vorversicherung.gesellschaft) = $event)),
                          class: "c-form-control__input",
                          placeholder: "Versicherungsgesellschaft",
                          minlength: "2",
                          maxlength: "40",
                          required: 
              _ctx.piniaStore.state.vorversicherung.antragsart === 'wechsel' ||
              (_ctx.piniaStore.state.vorversicherung.antragsart === 'neu' &&
                _ctx.piniaStore.state.vorversicherung.vorhanden === true)
            ,
                          "aria-required": 
              _ctx.piniaStore.state.vorversicherung.antragsart === 'wechsel' ||
              (_ctx.piniaStore.state.vorversicherung.antragsart === 'neu' &&
                _ctx.piniaStore.state.vorversicherung.vorhanden === true)
            ,
                          "aria-label": "Name des Vorversicherers",
                          "data-fehlermeldung": "Bitte geben Sie den Namen des Vorversicherers ein (max. 40 Zeichen)",
                          "data-cy": "vorversicherungGesellschaft"
                        }, null, 8, _hoisted_6), [
                          [
                            _vModelText,
                            _ctx.piniaStore.state.vorversicherung.gesellschaft,
                            void 0,
                            {
                              lazy: true,
                              trim: true
                            }
                          ]
                        ]),
                        _createVNode(_component_validierungs_fehler, {
                          "fehler-text": _ctx.fehler.vorversicherungGesellschaft
                        }, null, 8, ["fehler-text"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.piniaStore.state.isMakler)
                  ? (_openBlock(), _createBlock(_component_zeile, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_titel_zelle, null, {
                          default: _withCtx(() => _cache[18] || (_cache[18] = [
                            _createTextVNode("Versicherungsscheinnummer")
                          ])),
                          _: 1,
                          __: [18]
                        }),
                        _createVNode(_component_zelle, null, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              id: "versicherungsscheinnummer-transfer",
                              name: "versicherungsscheinnummer",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.piniaStore.state.vorversicherung.versicherungsscheinnummer) = $event)),
                              class: "c-form-control__input",
                              placeholder: "Versicherungsscheinnummer",
                              minlength: "2",
                              maxlength: "30",
                              "aria-label": "Versicherungsscheinnummer",
                              "data-fehlermeldung": "Bitte geben Sie die Versicherungsscheinnummer ein (max. 30 Zeichen)",
                              "data-cy": "versicherungsscheinnummer-transfer"
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.piniaStore.state.vorversicherung.versicherungsscheinnummer,
                                void 0,
                                {
                                  lazy: true,
                                  trim: true
                                }
                              ]
                            ]),
                            _createVNode(_component_validierungs_fehler, {
                              "fehler-text": _ctx.fehler.versicherungsscheinnummer
                            }, null, 8, ["fehler-text"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (
          _ctx.piniaStore.state.vorversicherung.antragsart === 'wechsel' ||
          _ctx.piniaStore.state.vorversicherung.vorhanden === true
        )
                  ? (_openBlock(), _createBlock(_component_zeile, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_titel_zelle, null, {
                          default: _withCtx(() => _cache[19] || (_cache[19] = [
                            _createTextVNode("Wurde bereits gekündigt?")
                          ])),
                          _: 1,
                          __: [19]
                        }),
                        _createVNode(_component_zelle, null, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("select", {
                              id: "vorversicherungGekuendigtVon",
                              name: "vorversicherungGekuendigtVon",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.piniaStore.state.vorversicherung.gekuendigtVon) = $event)),
                              class: "c-form-control-select",
                              required: 
              _ctx.piniaStore.state.vorversicherung.antragsart === 'wechsel' ||
              (_ctx.piniaStore.state.vorversicherung.antragsart === 'neu' &&
                _ctx.piniaStore.state.vorversicherung.vorhanden === true)
            ,
                              "aria-required": 
              _ctx.piniaStore.state.vorversicherung.antragsart === 'wechsel' ||
              (_ctx.piniaStore.state.vorversicherung.antragsart === 'neu' &&
                _ctx.piniaStore.state.vorversicherung.vorhanden === true)
            ,
                              "aria-label": "Wurde bereits gekündigt?",
                              "data-fehlermeldung": "Bitte wählen Sie den Kündigungsstatus aus."
                            }, [
                              _cache[20] || (_cache[20] = _createElementVNode("option", { value: "" }, "Bitte wählen", -1)),
                              _createElementVNode("option", _hoisted_8, _toDisplayString(_ctx.piniaStore.state.isMakler
                  ? "Ja, die Kündigung ist durch den Versicherungsnehmer erfolgt"
                  : "Ja, ich habe bereits gekündigt"), 1),
                              _createElementVNode("option", _hoisted_9, _toDisplayString(_ctx.piniaStore.state.isMakler
                  ? "Ja, die Versicherung hat dem Versicherungsnehmer gekündigt"
                  : "Ja, meine Versicherung hat mir gekündigt"), 1),
                              _cache[21] || (_cache[21] = _createElementVNode("option", { value: "no" }, "Nein", -1))
                            ], 8, _hoisted_7), [
                              [_vModelSelect, _ctx.piniaStore.state.vorversicherung.gekuendigtVon]
                            ]),
                            _createVNode(_component_validierungs_fehler, {
                              "fehler-text": _ctx.fehler.vorversicherungGekuendigtVon,
                              "reduzierter-abstand": true
                            }, null, 8, ["fehler-text"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_zeile, null, {
                  default: _withCtx(() => [
                    (_ctx.piniaStore.state.vorversicherung.antragsart === 'wechsel')
                      ? (_openBlock(), _createBlock(_component_titel_zelle, { key: 0 }, {
                          default: _withCtx(() => _cache[22] || (_cache[22] = [
                            _createTextVNode("Vertragsende beim Vorversicherer ")
                          ])),
                          _: 1,
                          __: [22]
                        }))
                      : (_openBlock(), _createBlock(_component_titel_zelle, { key: 1 }, {
                          default: _withCtx(() => _cache[23] || (_cache[23] = [
                            _createTextVNode("Vertragsende der Vorversicherung")
                          ])),
                          _: 1,
                          __: [23]
                        })),
                    _createVNode(_component_zelle, { breite: 3 }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          id: "vorversicherungVertragEnde",
                          name: "vorversicherungVertragEnde",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.piniaStore.state.vorversicherung.vertragEnde) = $event)),
                          class: "c-form-control__input",
                          title: "Enddatum im Format TT.MM.JJJJ",
                          minlength: "10",
                          maxlength: "10",
                          pattern: "[0-9]{4}-[0-9]{2}-[0-9]{2}",
                          required: 
              _ctx.piniaStore.state.vorversicherung.antragsart === 'wechsel' ||
              (_ctx.piniaStore.state.vorversicherung.antragsart === 'neu' &&
                _ctx.piniaStore.state.vorversicherung.vorhanden === true)
            ,
                          "aria-required": 
              _ctx.piniaStore.state.vorversicherung.antragsart === 'wechsel' ||
              (_ctx.piniaStore.state.vorversicherung.antragsart === 'neu' &&
                _ctx.piniaStore.state.vorversicherung.vorhanden === true)
            ,
                          "aria-label": "Vertragsende",
                          "data-fehlermeldung": "Bitte geben Sie das Ablaufdatum des bisherigen Vertrags ein (TT.MM.JJJJ)",
                          "data-cy": "vorversicherungVertragEnde"
                        }, null, 8, _hoisted_10), [
                          [
                            _vModelText,
                            _ctx.piniaStore.state.vorversicherung.vertragEnde,
                            void 0,
                            { lazy: true }
                          ]
                        ]),
                        _createVNode(_component_validierungs_fehler, {
                          "fehler-text": _ctx.fehler.vorversicherungVertragEnde
                        }, null, 8, ["fehler-text"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.piniaStore.state.vorversicherung.antragsart === 'aenderung')
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_ctx.piniaStore.state.isMakler)
                  ? (_openBlock(), _createBlock(_component_zeile, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_titel_zelle, null, {
                          default: _withCtx(() => _cache[24] || (_cache[24] = [
                            _createTextVNode("Versicherungsscheinnummer")
                          ])),
                          _: 1,
                          __: [24]
                        }),
                        _createVNode(_component_zelle, null, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              id: "versicherungsscheinnummer-modification",
                              name: "versicherungsscheinnummer",
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.piniaStore.state.vorversicherung.versicherungsscheinnummer) = $event)),
                              class: "c-form-control__input",
                              placeholder: "Versicherungsscheinnummer",
                              minlength: "2",
                              maxlength: "40",
                              disabled: _ctx.istAenderungsantragMitVorbelegung,
                              "aria-label": "Versicherungsscheinnummer",
                              "data-fehlermeldung": "Bitte geben Sie die Versicherungsscheinnummer ein (max. 40 Zeichen)",
                              "data-cy": "versicherungsscheinnummer-modification"
                            }, null, 8, _hoisted_12), [
                              [
                                _vModelText,
                                _ctx.piniaStore.state.vorversicherung.versicherungsscheinnummer,
                                void 0,
                                {
                                  lazy: true,
                                  trim: true
                                }
                              ]
                            ]),
                            _createVNode(_component_validierungs_fehler, {
                              "fehler-text": _ctx.fehler.versicherungsscheinnummer
                            }, null, 8, ["fehler-text"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_component_zeile, null, {
      default: _withCtx(() => [
        _createVNode(_component_titel_zelle, null, {
          default: _withCtx(() => _cache[25] || (_cache[25] = [
            _createTextVNode("Versicherungsbeginn bei der GEV (12:00 Uhr)")
          ])),
          _: 1,
          __: [25]
        }),
        _createVNode(_component_zelle, { breite: 3 }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("input", {
              type: "date",
              id: "tariffStartDate",
              name: "tariffStartDate",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.versicherungsBeginn) = $event)),
              class: "c-form-control__input",
              "data-cy": "versicherungsbeginn",
              title: "Versicherungsbeginn im Format TT.MM.JJJJ",
              min: _ctx.versicherungsBeginnMin,
              max: _ctx.maxVersicherungsBeginn,
              minlength: "10",
              maxlength: "10",
              pattern: "[0-9]{4}-[0-9]{2}-[0-9]{2}",
              required: "",
              "aria-required": "true",
              "aria-label": "Versicherungsbeginn bei der GEV"
            }, null, 8, _hoisted_13), [
              [
                _vModelText,
                _ctx.versicherungsBeginn,
                void 0,
                {
                  lazy: true,
                  trim: true
                }
              ]
            ]),
            _createVNode(_component_validierungs_fehler, {
              "fehler-text": _ctx.fehler.tariffStartDate
            }, null, 8, ["fehler-text"])
          ]),
          _: 1
        }),
        (_ctx.piniaStore.state.vorversicherung.antragsart === 'wechsel')
          ? (_openBlock(), _createBlock(_component_zelle, {
              key: 0,
              breite: 4
            }, {
              default: _withCtx(() => _cache[26] || (_cache[26] = [
                _createElementVNode("span", { style: {"color":"#666666"} }, [
                  _createTextVNode(" Für lückenlosen Versicherungsschutz empfehlen wir, "),
                  _createElementVNode("strong", null, "Vertragsende"),
                  _createTextVNode(" und "),
                  _createElementVNode("strong", null, "Versicherungsbeginn am gleichen Tag"),
                  _createTextVNode(" zu wählen. "),
                  _createElementVNode("strong", null, "Ausnahme: 29. Februar und rückwirkender Versicherungsbeginn")
                ], -1)
              ])),
              _: 1,
              __: [26]
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.ablaufSichtbar)
      ? (_openBlock(), _createBlock(_component_zeile, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_component_titel_zelle, null, {
              default: _withCtx(() => _cache[27] || (_cache[27] = [
                _createTextVNode("Ablauf")
              ])),
              _: 1,
              __: [27]
            }),
            _createVNode(_component_zelle, { class: "mkRadio" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.piniaStore.state.tarifinformationen.ablauf) = $event)),
                  type: "radio",
                  id: "ablaufEinJahr",
                  name: "ablauf",
                  value: "einJahr",
                  "data-cy": "ablaufEinJahr",
                  required: "",
                  "aria-required": "true",
                  "aria-label": "Versicherungsablauf"
                }, null, 512), [
                  [_vModelRadio, _ctx.piniaStore.state.tarifinformationen.ablauf]
                ]),
                _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.beginnInEinemJahr), 1),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.piniaStore.state.tarifinformationen.ablauf) = $event)),
                  type: "radio",
                  id: "ablaufJanuar",
                  name: "ablauf",
                  value: "januar",
                  "data-cy": "ablaufJanuar",
                  "aria-label": "Versicherungsablauf zum 01. Januar"
                }, null, 512), [
                  [_vModelRadio, _ctx.piniaStore.state.tarifinformationen.ablauf]
                ]),
                (!_ctx.beginnErsterTagDesJahres)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_15, _toDisplayString(_ctx.naechsterJanuar), 1))
                  : _createCommentVNode("", true),
                _createVNode(_component_validierungs_fehler, {
                  "fehler-text": _ctx.fehler.ablauf,
                  "reduzierter-abstand": true
                }, null, 8, ["fehler-text"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}